import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { type Exercise } from "types/course/topics"

interface TopicState {
  currentSelectedTopic: Exercise | null
}

const initialState: TopicState = {
  currentSelectedTopic: null,
}

const TopicSlice = createSlice({
  name: "topic",
  initialState,
  reducers: {
    setCurrentSelectedTopic: (state, action: PayloadAction<Exercise | null>) => {
      state.currentSelectedTopic = action.payload
    },
    resetState: () => initialState,
  },
})

export const { resetState, setCurrentSelectedTopic } = TopicSlice.actions
export default TopicSlice.reducer
